<template lang="html">
  <img :src="logo" alt="logo" :class="className" />
</template>

<script>
import Logo from '@/assets/images/logo-rever.svg'

export default {
  name: 'ReverLogo',

  props: {
    type: {
      type: String,
      required: false,
      default: 'normal',
    },
  },

  data() {
    return {
      logo: Logo,
    }
  },

  computed: {
    className() {
      return this.type === 'big' ? 'rever-logo-big' : 'rever-logo'
    },
  },
}
</script>

<style lang="scss" scoped>
.rever-logo {
  width: 100px;
  margin: 0px;
  display: block;
}

.rever-logo-big {
  width: 120px;
  height: 33px;
  margin: 0px;
  display: block;
}
</style>
